import { useAtom } from "jotai";
import React from "react";
import styled from "styled-components";
import { answerCountAtom } from "../jotai/common";
import KakaoAd from "./KakaoAd";
import KakaoShareButtonT from "./KakaoShareButtonT";
import MainButton from "./MainButton";
import { Container } from "./styled";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const ResultScreen = ({ setScreen }: Props) => {
  const [answerCount] = useAtom(answerCountAtom);
  const totalCount = 7;

  return (
    <ResultContainer>
      <Title>당신의 결과</Title>
      <Content>
        {answerCount} / {totalCount}
      </Content>
      <KakaoShareButtonT
        isResult
        desc={`나는 ${answerCount}개 맞췄어.. 너도 풀어봐`}
      />
      <MainButton
        onClick={() => {
          setScreen("main");
        }}
      >
        메인으로 가기
      </MainButton>

      <KakaoAd adUnit="DAN-TQKAeWxq7WkNU1tn" adWidth="300" adHeight="250" />
    </ResultContainer>
  );
};

export default ResultScreen;

const ResultContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  justify-content: center;
  min-height: calc(100vh - 100px);
`;

const Title = styled.div`
  font-size: 45px;
  text-align: center;
`;

const Content = styled.div`
  font-size: 30px;
  text-align: center;
`;
